import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CasesRequest, GetTheftReportRes, GetTheftReportsOpts, SharedInvestigation, ShareRequest } from '../types';
import { createHttpParamsFromRecord } from '../secure/common/helpers';

@Injectable({
  providedIn: 'root',
})
export class TheftReportService {
  apiHost = `${environment.apiBaseUrl}`;

  private httpClient = inject(HttpClient);

  getSharedInvestigation(reviewId: string, from?: string) {
    let requestUrl = `${this.apiHost}/TheftReport/Investigation/${reviewId}/Shared`;
    if (from) requestUrl += `?from=${encodeURIComponent(from)}`;
    return this.httpClient.get<SharedInvestigation>(requestUrl);
  }

  shareInvestigation(reviewId: string, request: ShareRequest): Observable<void> {
    const requestUrl = `${this.apiHost}/TheftReport/Investigation/${reviewId}/Share`;
    return this.httpClient.post<void>(requestUrl, request);
  }

  mergeCases(request: CasesRequest) {
    const requestUrl = `${this.apiHost}/TheftReport/MergeCases`;
    return this.httpClient.post<unknown>(requestUrl, request);
  }

  markNoTheft(request: CasesRequest) {
    const requestUrl = `${this.apiHost}/TheftReport/MarkNoTheft`;
    return this.httpClient.post<unknown>(requestUrl, request);
  }

  getTheftReport(shareKey: string, opts?: GetTheftReportsOpts, apiKey?: string): Observable<GetTheftReportRes> {
    const requestUrl = `${this.apiHost}/TheftReport/Shared/${shareKey}`;
    const options: { headers?: HttpHeaders; params: HttpParams } = {
      params: createHttpParamsFromRecord(opts),
    };

    if (apiKey) options.headers = new HttpHeaders().set('x-api-key', apiKey);
    return this.httpClient.get<GetTheftReportRes>(requestUrl, options);
  }
}
